<template>
  <q-page>
    <div class="justify-center row">
      <div v-if="$apollo.loading">
        {{isLoading()}}
      </div>
      <div v-if="!$apollo.loading" class="col-10 q-pa-md">
      {{$q.loading.hide()}}
        <h2 class="q-mt-sm q-mb-sm text-center">{{groupOrder.name}}</h2>
        <div class="text-h4 text-center">(Group Order)</div>
        <h3>Details</h3>
        <div class="col q-gutter-md">
          <m-edit-item field="name" type="popup" graphqlType="GroupOrder" :id="id" />
          <m-edit-item field="openDate" type="datetime" graphqlType="GroupOrder" :id="id" />
          <m-edit-item field="closeDate" type="datetime" graphqlType="GroupOrder" :id="id" />
          <m-edit-item field="isOpen" type="checkbox" graphqlType="GroupOrder" :id="id" :update-function="updateIsOpen"/>
        </div>
        <h3 class="q-mb-none">Notes</h3>
        <m-edit-item label-type="none" autogrow field="notes" type="input" graphqlType="GroupOrder" :id="id"/>
        <h3 class="q-mb-none">Customer Orders</h3>
        <!-- {{groupOrder.customerOrders}} -->
        <q-table :columns="ordersColumns"
                 :data="groupOrder.customerOrders" flat
                 :pagination.sync="pagination"
                 :filter="filter"
                 binary-state-sort
                 row-key="orderId">
<!--          <template v-slot:top>-->
<!--            <q-space />-->
<!--            <q-input dense debounce="300" color="primary" v-model="filter">-->
<!--              <template v-slot:append>-->
<!--                <q-icon name="search" />-->
<!--              </template>-->
<!--            </q-input>-->
<!--          </template>-->
          <template v-slot:body-cell-verified="props">
            <q-td :props="props">
              <q-checkbox disabled :value="props.value"></q-checkbox>
            </q-td>
          </template>
          <template v-slot:body-cell-orderNumber="props">
            <q-td :props="props">
              <router-link :to="`/admin/container-orders/${props.row.id}`">{{props.row.orderNumber}}</router-link>
            </q-td>
          </template>
          <template v-slot:body-cell-company="props">
            <q-td :props="props">
              <router-link :to="`/admin/accounts/${props.row.account.id}`">{{props.row.account.companyName}}</router-link>
            </q-td>
          </template>
          <template v-slot:body-cell-actions="props">
            <q-td :props="props">
              <span>
                <q-btn dense flat icon="save_alt" size="sm" :disabled="!canGenerateBrandOrdersForCustomerOrder(props.row)"
                       @click="generateBrandOrdersForCustomerOrder(props.row)"/>
                <q-tooltip>
                  Generate Brand Orders for this Order.
                  <span v-if="!canGenerateBrandOrdersForCustomerOrder(props.row)">
                    <ul>
                      <li>Ensure this order <em>is</em> verified.</li>
                      <li>Ensure you've deleted all BrandOrders first.</li>
                    </ul>
                  </span>
                </q-tooltip>
              </span>
              <span>
                <q-btn dense flat icon="delete" size="sm" :disabled="!canDeleteBrandOrdersForCustomerOrder(props.row)"
                       @click="deleteBrandOrdersForCustomerOrderAndUnverifyWithDialog(props.row)"/>
                <q-tooltip>
                  Delete Brand Orders related to this Order.
                  <span v-if="!canDeleteBrandOrdersForCustomerOrder(props.row)">
                    <ul>
                      <li>Are there any related Brand Orders to be deleted?</li>
                    </ul>
                  </span>
                </q-tooltip>
              </span>
            </q-td>
          </template>
        </q-table>
        <template>{{orderTotals}}</template>
        <div class="row text-h4">
          <div>Discounted Total Cost:</div>
          <div style="margin-left:10px">{{formatCurrency(orderDiscountedTotalCost)}}</div>
        </div>    
        <br>    
        <div class="row text-h4">
          <div>Total Cost:</div>
          <div style="margin-left:10px">{{formatCurrency(orderRawTotalCost)}}</div>
        </div>
        <h3 class="q-mb-none">Brand Orders</h3>
        <div  v-if="showProcessMsg" class="text-center text-bold blink_me" style="padding:10px; margin:20px 50px;">Generating new brand orders...please wait</div>
        <div v-if="!(groupOrder||{}).brandOrders.length">
          <q-btn class="full-width q-my-md" outline
                 :disable="!!(((groupOrder||{}).customerOrders||[]).filter(o => !o.verified).length || groupOrder.isOpen)"
                 @click="generateBrandOrders">
            Generate Brand Orders
          </q-btn>
          <div class="text-red">
            <div v-if="groupOrder.isOpen">Group Order is still open.  Close it first.</div>
            <div :key="order.orderNumber" v-for="order in ((groupOrder||{}).customerOrders||[]).filter(o => !o.verified)">Order {{order.orderNumber}} has not been verified.</div>
          </div>
        </div>

        <q-table :columns="brandOrdersColumns"
                 :data="groupOrder.brandOrders" flat
                 :pagination.sync="pagination"
                 :filter="filter"
                 v-if="(groupOrder||{}).brandOrders.length"
                 row-key="orderId">
          <!--          <template v-slot:top>-->
          <!--            <q-space />-->
          <!--            <q-input dense debounce="300" color="primary" v-model="filter">-->
          <!--              <template v-slot:append>-->
          <!--                <q-icon name="search" />-->
          <!--              </template>-->
          <!--            </q-input>-->
          <!--          </template>-->
          <template v-slot:body-cell-orderNumber="props">
            <q-td :props="props">
              <router-link :to="`/admin/brand-orders/${props.row.id}`">{{props.value}}</router-link>
            </q-td>
          </template>
          <template v-slot:body-cell-company="props">
            <q-td :props="props">
              <router-link :to="`/admin/accounts/${((props.row.customerOrder||{}).account||{}).id}`">{{props.value}}</router-link>
            </q-td>
          </template>
          <template v-slot:body-cell-customerOrder="props">
            <q-td :props="props">
              <router-link :to="`/admin/container-orders/${props.value.id}`">{{props.value.orderNumber}}</router-link>
            </q-td>
          </template>

          <template v-slot:body-cell-actions="props">
            
            <q-td :props="props">
              
              <span>
                <q-btn dense flat icon="save_alt" size="sm" @click="downloadOrderForm(props.row)"></q-btn>
                <q-tooltip>Download the order form.</q-tooltip>
              </span>
             <span v-if="props.row.customerOrder.account.companyName == 'ICP'">
               <!-- <q-btn dense flat icon="" size="sm" @click="addStockFromOrder(props.row)"></q-btn>
                -->
              <router-link :to="`/admin/add-stock-from-group-order/${props.row.id}`"><q-icon color="black" name="switch_access_shortcut_add"></q-icon></router-link>
              <q-tooltip>Add Stock from Order</q-tooltip>
             </span>            
             <!-- <span v-if="xlsSupported.includes(props.row.items[0].sku.product.attributes.brand.toLowerCase())">
               <q-btn dense flat icon="grid_4x4" size="sm" @click="downloadXLSX(props.row)"></q-btn>
               <q-tooltip>Download Spreadsheet Order </q-tooltip>
             </span>               -->
             <!-- <span> -->
<!--                <q-btn dense flat icon="save" size="sm" @click="magic(props.row)"></q-btn>-->
<!--                <q-tooltip>Download the order form.</q-tooltip>-->
<!--              </span>-->
            </q-td>
          </template>

          <template v-slot:bottom-row>
            <q-tr v-if="!allBrandOrdersGenerated()">
              <q-td colspan="100%">
                <div class="text-red">
                  Important Problems:<br/>
                  <div v-if="groupOrder.isOpen">Group Order is still open.</div>
                  <div :key="order.orderNumber"
                       v-for="order in ((groupOrder||{}).customerOrders||[]).filter(o => !customerOrderBrandOrders(o).length)">
                    {{order.orderNumber}} has doesn't have any Brand Orders generated!
                  </div>
                </div>
              </q-td>
            </q-tr>
          </template>

        </q-table>
        <q-btn v-if="(groupOrder||{}).brandOrders.length" @click="downloadAllOrderForms">Download All Order Forms</q-btn>
        <q-btn v-if="(groupOrder||{}).brandOrders.length" @click="generateFilledOrderForms">Generate Filled Order Forms</q-btn>        
      </div>
    </div>

    <q-dialog v-model="uploadOrderFormShowing">
      <q-card>
        <q-uploader
          :factory="uploaderFactoryOrderForm"
          label="Order Form"
          :max-file-size="10000000"
          accept=".xls,.xlsx"
          auto-upload
          hide-upload-btn
          style="max-width: 300px"
        />
      </q-card>
    </q-dialog>
  </q-page>
</template>

<style>
</style>

<script>
import gql from 'graphql-tag'
import JSZip from 'jszip'
import * as xlsx from 'xlsx'
import saveAs from 'file-saver'
import MEditItem from '../../components/ui/admin/MEditItem'
import { formatCurrency, formatDate } from '../../util/string'
import adminNotifyError from '../../util/adminNotifyError'


export default {
  name: 'PageAdminGroupOrder',
  components: { MEditItem },
  apollo: {
    groupOrder () {
      return {
        query: gql`
        query groupOrder ($id: ID!) {
          groupOrder (id: $id) {
            id
            name
            notes
            isOpen
            openDate
            closeDate
            customerOrders {
              id
              orderNumber
              name
              notes
              account {
                id
                companyName
              }
              placed
              verified
              delivered
              createdAt
              updatedAt
              totalCost
              items{
                id
                skuId
                itemCost
                qty
                discountPercent
                totalCost
              }
            }
            brandOrders {
              id
              name
              orderNumber
              filter
              totalCost
              submitted
              customerOrder {
                  id
                  orderNumber
                  account {
                    companyName
                    id
                  }
              }
              items {
                id
                qty
                itemCost
                totalCost
                sku {
                  id
                  options
                  product {
                    id
                    attributes
                    name
                    reference
                  }
                }
              }
            }
          }
        }
      `,
        variables: {
          id: this.id
        },
        fetchPolicy: 'network-only'
      }
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    orderTotals(){
      let rawTotal = 0;
      let discountedTotal = 0;
      for(let order of this.groupOrder.customerOrders){
        for(let item of order.items){
          rawTotal += (item.itemCost * item.qty);
          discountedTotal += item.totalCost;
        }
      }
      this.orderDiscountedTotalCost = discountedTotal;
      this.orderRawTotalCost = rawTotal;
    }
  },
  methods: {
    isLoading(message){
      let msg = (message) ? message : 'Loading Group Order. This process usually takes time. Please wait...'
      this.$q.loading.show({
          message: msg,
          boxClass: 'bg-grey-2 text-grey-9',
          spinnerColor: 'primary',
          html: true
        })
    },
    getRawTotalCost(items){
      let total = 0;
      for(let item of items){
        total = total + (item.qty * item.itemCost)
      }
      return total
    },
    formatDate,
    formatCurrency,
    addStockFromOrder (row){
      console.log('ROW',row);    
    },
    generateFilledOrderForms(){
      console.log("Load Location DB")
    },
    async downloadAllOrderForms () {
      console.log('CALLING');
      console.log('GROUP ORDERS',this.groupOrder);
      
      
      let zip = new JSZip()
      for (const brandOrder of this.groupOrder.brandOrders) {
        console.log('brandOrder.id',brandOrder.id);
        
        const csvData = await this.fetchOrderCsv(brandOrder.id)
        zip.file(`${this.findFieldInFilter(brandOrder, 'manufacturer').replace(' ', '')}/${brandOrder.orderNumber}_${this.findFieldInFilter(brandOrder, 'manufacturer').replace(' ', '')}_${this.findFieldInFilter(brandOrder, 'brand')}_${brandOrder?.customerOrder?.account?.companyName}.csv`,
          Buffer.alloc(csvData.length, csvData))
      }
      zip.generateAsync({ type: 'uint8array' }).then(buf => {
        saveAs(new Blob([buf]), `${this.groupOrder?.name}_order_forms.zip`)
      })
    },
    async fetchOrderCsv (brandOrderId) {
      const result = await this.$apollo.mutate({
        mutation: gql`
          mutation ($id: ID!) {
            outputBrandOrderAsCsv (id: $id)
          }
        `,
        variables: {
          id: brandOrderId
        }
      })
      return result.data.outputBrandOrderAsCsv
    },
    async magic (row) {
      this.uploadOrderFormShowing = true
      this.uploadingRow = row
    },
    async uploaderFactoryOrderForm (files) {
      if (!files || !files.length) return
      try {
        let fileContent = await files[0].arrayBuffer()
        let data = new Uint8Array(fileContent)
        let arr = []
        for (let i = 0; i < data.length; ++i) arr[i] = String.fromCharCode(data[i])
        let bstr = arr.join('')
        let orderForm = await xlsx.read(bstr, { type: 'binary' })

        let holdsSheet = xlsx.utils.sheet_to_json(orderForm.Sheets['Holds'], { range: 'A4:U200', raw: false })
        let volumesSheet = xlsx.utils.sheet_to_json(orderForm.Sheets['Volumes'], { range: 'A5:O100', raw: false })

        debugger
        // for (const item of this.uploadingRow.items.filter(i => i.sku?.product?.attributes?.type === 'Hold')) {
        //   console.log(item)
        // }

        for (const item of this.uploadingRow.items.filter(i => i.sku?.product?.attributes?.type === 'Fiberglass Volume')) {
          // console.log(item)
          const match = volumesSheet.find(row => row['Set'] === item.sku?.product?.reference)
          console.log(match)
          if (!match) {
            console.log(`Unmatched: ${item.sku?.product?.reference}`)
            continue
          }
          const colourCol = item.sku?.options?.colour?.name
          if (!colourCol) throw Error('unknown colour?')
          match[colourCol] = item.qty
        }

        debugger
        orderForm.Sheets['Holds'] = xlsx.utils.json_to_sheet(holdsSheet)
        orderForm.Sheets['Volumes'] = xlsx.utils.json_to_sheet(volumesSheet)

        xlsx.writeFile(orderForm, 'out.xlsx')
        debugger

        this.uploadOrderFormShowing = false
        this.uploadingRow = null
      } catch (ex) {
        console.log(ex)
      }
      // this.colours = []
      // for (const csvrow of colourData) {
      //   const colour = {
      //     name: csvrow['Name'],
      //     oldDatabaseName: csvrow['Old Database Name'],
      //     group: csvrow['Group'],
      //     superGroup: csvrow['Supergroup'],
      //     hex: csvrow['Hex Code']
      //   }
      //   if (csvrow['RAL Name']) colour.ralName = csvrow['RAL Name']
      //   if (csvrow['Pantone Name']) colour.pantoneName = csvrow['Pantone Name']
      //   if (csvrow['Aragon Name']) colour.aragonName = csvrow['Aragon Name']
      //   if (csvrow['CompX Name']) colour.compxName = csvrow['CompX Name']
      //
      //   this.colours.push(colour)
      // }
      // this.validateAllRows()
    },
    async downloadOrderForm (row) {
      try {
        const csvData = await this.fetchOrderCsv(row.id);
        saveAs(new Blob([csvData], { type: 'application/octet-stream' }), `ICP_${row.orderNumber}.csv`)
      } catch (exception) {
        console.log(exception)
      }
    },
    async downloadXLSX (row) {
      try {
        const csvData = await this.fetchOrderCsv(row.id);
        console.log('CSV DATA',csvData);
        
        // saveAs(new Blob([csvData], { type: 'application/octet-stream' }), `ICP_${row.orderNumber}.csv`)
      } catch (exception) {
        console.log(exception)
      }
    },    
    async generateBrandOrders () {
      this.showProcessMsg = true;
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation ($id: ID!) {
              generateBrandOrders (id: $id) {
                id
                name
                notes
                isOpen
                openDate
                closeDate
                customerOrders {
                  id
                  orderNumber
                  name
                  notes
                  account {
                    id
                    companyName
                  }
                  placed
                  verified
                  delivered
                  createdAt
                  updatedAt
                  totalCost
                }
                brandOrders {
                  id
                  name
                  orderNumber
                  filter
                  totalCost
                  submitted
                  customerOrder {
                      id
                      orderNumber
                      account {
                        companyName
                        id
                      }
                  }
                  items {
                    id
                    qty
                    sku {
                      id
                      options
                      product {
                        id
                        attributes
                        name
                        reference
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: {
            id: this.id
          }
        })
        this.$apollo.queries.groupOrder.refetch()
        this.showProcessMsg = false;
      } catch (error) {
        this.showProcessMsg = false;
        adminNotifyError(this.$q, 'Error Generating Brand Orders', error)
      }
    },
    async updateIsOpen (newVal) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
              mutation setActiveGroupOrder ($id: ID) {
                setActiveGroupOrder ( id: $id )
              }
            `,
          variables: {
            id: newVal ? this.id : null
          }
        })
        this.$apollo.queries.groupOrder.refetch()
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to set active group order!', error)
      }
    },
    findFieldInFilter (row, field) {
      // example of field is 'manufacturer'
      // return row?.filter?.split('\n')?.find(r => r.startsWith(field))?.replace(`${field}: `, '')
      return row?.filter?.split('\n')?.find(r => r.startsWith(field))?.replace(field + ": ", '')
    },
    allBrandOrdersGenerated () {
      // Returns true if every customer order has at least one brand order
      return !!this.groupOrder.customerOrders.every(customerOrder => {
        return !!this.customerOrderBrandOrders(customerOrder).length
      })
    },
    customerOrderBrandOrders (customerOrder) {
      return this.groupOrder.brandOrders.filter(brandOrder => brandOrder.customerOrder.id === customerOrder.id)
    },
    canGenerateBrandOrdersForCustomerOrder (customerOrder) {
      if (!customerOrder.verified) return false
      return !this.groupOrder.brandOrders.find(brandOrder => brandOrder.customerOrder.id === customerOrder.id)
    },
    canDeleteBrandOrdersForCustomerOrder (customerOrder) {
      if (!customerOrder.verified) return false
      return !!this.groupOrder.brandOrders.find(brandOrder => brandOrder.customerOrder.id === customerOrder.id)
    },
    async generateBrandOrdersForCustomerOrder (customerOrder) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation generateBrandOrdersForContainerOrder ($id: ID!) {
              generateBrandOrdersForContainerOrder ( id: $id ) {
                id
                orderNumber
                name
                notes
                account {
                  id
                  companyName
                }
                placed
                verified
                delivered
                createdAt
                updatedAt
                totalCost
                groupOrder {
                  id
                  name
                  notes
                  isOpen
                  openDate
                  closeDate
                  brandOrders {
                    id
                    name
                    orderNumber
                    filter
                    totalCost
                    submitted
                    customerOrder {
                        id
                        orderNumber
                        account {
                          companyName
                          id
                        }
                    }
                    items {
                      id
                      qty
                      sku {
                        id
                        options
                        product {
                          id
                          attributes
                          name
                          reference
                        }
                      }
                    }
                  }
                }
              }
            }
            `,
          variables: {
            id: customerOrder.id
          }
        })
        // this.$apollo.queries.groupOrder.refetch()
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to create BrandOrders!', error)
      }
    },
    deleteBrandOrdersForCustomerOrderAndUnverifyWithDialog (customerOrder) {
      this.$q.dialog({
        title: 'Delete Brand Orders',
        html: true,
        message: `<p>Are you sure you want to delete the following BrandOrders associated with ${customerOrder.orderNumber}?</p>
<ul>
    ${this.customerOrderBrandOrders(customerOrder).map(o => `<li>${o.orderNumber}</li>`).join('')}
</ul>
<p>This will also unverify ${customerOrder.orderNumber}.  You won't be able to re-verify it until you delete the original Xero invoice!</p>`,
        cancel: true
      }).onOk(() => {
        this.deleteBrandOrdersForCustomerOrderAndUnverify(customerOrder)
      })
    },
    async deleteBrandOrdersForCustomerOrderAndUnverify (customerOrder) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation deleteBrandOrdersForContainerOrderAndUnverify ($id: ID!) {
              deleteBrandOrdersForContainerOrderAndUnverify ( id: $id ) {
                id
                orderNumber
                name
                notes
                account {
                  id
                  companyName
                }
                placed
                verified
                delivered
                createdAt
                updatedAt
                totalCost
                groupOrder {
                  id
                  name
                  notes
                  isOpen
                  openDate
                  closeDate
                  brandOrders {
                    id
                    name
                    orderNumber
                    filter
                    totalCost
                    submitted
                    customerOrder {
                        id
                        orderNumber
                        account {
                          companyName
                          id
                        }
                    }
                    items {
                      id
                      qty
                      sku {
                        id
                        options
                        product {
                          id
                          attributes
                          name
                          reference
                        }
                      }
                    }
                  }
                }
              }
            }
            `,
          variables: {
            id: customerOrder.id
          }
        })
        // this.$apollo.queries.groupOrder.refetch()
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to delete BrandOrders!', error)
      }
    }
  },
  data () {
    return {
      showProcessMsg: false,
      orderRawTotalCost:0,
      orderDiscountedTotalCost:0,
      order: {},
      model: null,
      xlsSupported: ['tension','satellite'],
      filteredProducts: [],
      ordersColumns: [
        { name: 'verified', align: 'left', required: true, label: 'Verified', field: row => !!row.verified, sortable: true },
        { name: 'orderNumber', align: 'left', required: true, label: 'Order #', field: 'orderNumber', sortable: true },
        { name: 'company', align: 'left', required: true, label: 'Company', field: row => row.account.companyName, sortable: true },
        { name: 'name', align: 'left', required: true, label: 'Name', field: 'name', sortable: true },
        { name: 'datePlaced', align: 'left', required: true, label: 'Date Submitted', field: row => row.placed, sortable: true, format: formatDate },
        { name: 'rawTotalCost', align: 'left', required: true, label: 'Total Cost', field: row => this.getRawTotalCost(row.items), sortable: true, format: formatCurrency },
        { name: 'totalCost', align: 'left', required: true, label: 'Value (Discounted)', field: row => Number(row.totalCost), sortable: true, format: formatCurrency },
        { name: 'actions', align: 'center', required: true, label: 'Actions', field: '', sortable: false }
      ],
      brandOrdersColumns: [
        { name: 'orderNumber', align: 'left', required: true, label: 'Order', field: 'orderNumber', sortable: true },
        { name: 'company', align: 'left', required: true, label: 'Company', field: row => row.customerOrder?.account?.companyName, sortable: true },
        { name: 'customerOrder', align: 'left', required: true, label: 'Customer Order #', field: row => row.customerOrder || {}, sortable: true },
        { name: 'manufacturer', align: 'left', required: true, label: 'Manufacturer', field: row => this.findFieldInFilter(row, 'manufacturer'), sortable: true },
        { name: 'brand', align: 'left', required: true, label: 'Brand', field: row => this.findFieldInFilter(row, 'brand'), sortable: true },
        { name: 'rawTotalCost', align: 'left', required: true, label: 'Total Cost', field: row => this.getRawTotalCost(row.items), sortable: true, format: formatCurrency },
        { name: 'totalCost', align: 'right', required: true, label: 'Value(Discounted)', field: row => Number(row.totalCost), sortable: true, format: formatCurrency },
        { name: 'submitted', align: 'right', required: true, label: 'Submitted', field: row => row.submitted, sortable: true, format: v => formatDate(v) || 'Not Submitted' },
        { name: 'actions', align: 'center', required: true, label: 'Actions', field: '', sortable: false }
      ],
      pagination: {
        rowsPerPage: 0
      },
      filter: '',
      uploadOrderFormShowing: false,
      uploadingRow: null
    }
  }
}
</script>

<style scoped>
.blink_me {
  animation: blinker 0.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.2;
  }
}
</style>
